import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { className } from "utils/strings";
import { ITagListItem } from "./types";

import "./TagListButton.scss";
import { metrics } from "utils/metrics";
import { Avatar } from "@mui/material";

interface ITagListButton {
  item: ITagListItem;
  visible: boolean;
  onWidth: (id: string, width: number) => void;
  onTagClick?: (name: string) => void;
  selectedTags?: string[];
}

export const TagListButton = (props: ITagListButton): JSX.Element => {
  const {
    selectedTags,
    item: { id, link, text },
    onWidth,
    onTagClick,
    visible
  } = props;
  const ref = useRef<any>(null);
  const tagClasses = className({
    "tagButton": true,
    "visible": visible,
    "hidden": !visible,
    "niche": id.indexOf("niche:") >= 0,
    "tag": id.indexOf("tag:") >= 0,
    "selected": !!selectedTags?.includes(text)
  });

  const handleTagClick = async () => {
    if (onTagClick) {
      onTagClick(text);
      await metrics.sendTagClicked({ tag: props.item.text });
    }
  };

  useEffect(() => {
    if (ref.current) {
      onWidth(id, ref.current.offsetWidth);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props, ref.current?.offsetWidth]);

  const renderButtonTag = () => {
    return (
      <button onClick={handleTagClick} className={tagClasses} ref={ref}>
        <span className="text">{text}</span>
      </button>
    );
  };

  const renderLinkTag = () => {
    return (
      <Link to={link} className={tagClasses} ref={ref}>
        <div className="nicheContainer">
          {props.item.thumbnail && (
            <Avatar
              src={props.item.thumbnail}
              sx={{ width: 24, height: 24 }}
            />
          )}
          <span className="text">{text}</span>
        </div>
      </Link>
    );
  };

  const renderTag = () => {
    if (onTagClick) {
      return renderButtonTag();
    }

    return renderLinkTag();
  };

  return (
    <>
      {renderTag()}
    </>
  );
};
